import React from 'react/addons';
import {FluxMixin} from 'fluxxor';
import cx from 'classnames';

import Icon from 'ofs/components/common/Icon';


var Modal = React.createClass({
  mixins: [
    FluxMixin(React)
  ],

  getInitialState() {
    return {
      loaded: false,
      modalStyle: {},
      modalClasses: []
    };
  },

  handleClose() {
    this.setState({loaded: false});
    this.close();
  },

  close() {
    this.getFlux().actions.layers.remove();
  },

  componentDidMount() {
    this.setState({
      loaded: true,
      modalStyle: this.props.modalStyle
    });
  },

  render() {
    const {popupAd, fullBleedModal} = this.props;
    var modalClasses = this.state.modalClasses.map(c => 'ofs-Modal--' + c);

    modalClasses.unshift('ofs-Modal');

    if (popupAd) {
      modalClasses.push('ofs-Modal--popupAd');
    }

    let modalContentClasses = cx({
      'ofs-Modal__Content': true,
      'u-no-padding': fullBleedModal,
    });

    return (
      <div className="ofs-Modal__Wrapper" onClick={this.handleClose}>
        <div ref="modal" role="dialog" className={cx.apply(this, modalClasses)}
          onClick={(event) => event.stopPropagation()} style={this.state.modalStyle}>
          <header className="ofs-Modal__Toolbar">
            {this.props.title ? <h1>{this.props.title}</h1> : null}
            <a href="javascript:;" onClick={this.handleClose} className="ofs-Modal__Close"><Icon glyph="cross" size="small" /></a>
          </header>
          <div className={modalContentClasses}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
});

export default Modal;




/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/Modal.jsx
 **/